const StripeKeyEvent = {
  fetchOne: 'stripe_key/fetch-one',
  onClear: 'stripe_key/on-clear',
  onEdit: 'stripe_key/on-edit',
  onEditSearchCondition: 'stripe_key/on-edit-search-condition',
  onSearch: 'stripe_key/on-search'
}

export default StripeKeyEvent
